// T-154 (v1.8.44, Session 40, 30.09.2026, Kundin-Mail 30.09. 18:08): Termine, die im Gästekalender nicht erscheinen
// (Termin nicht öffentlich oder Slot nicht verfügbar). Das Backend liefert sichtbarFuerGaeste nur an die Verwaltung
// (Business.Kalender.Gaestesichtbarkeit, gleiche Bedingung wie der Gästekalender). Gesperrte Termine zeigen schon "Blockiert".

export interface SichtbarkeitSlot {
  sichtbarFuerGaeste?: boolean | null;
  isBlocked?: boolean;
}

/** true, wenn der Termin für Gäste unsichtbar ist und nicht gesperrt (dann Hinweis und Schalter "sichtbar machen"). */
export function istUnsichtbarFuerGaeste(slot: SichtbarkeitSlot | null | undefined): boolean {
  return !!slot && slot.sichtbarFuerGaeste === false && !slot.isBlocked;
}

export const HINWEIS_UNSICHTBAR =
  'FÜR GÄSTE UNSICHTBAR: Dieser Termin erscheint nicht im Kalender auf der Webseite (auch nicht "auf Anfrage").';
